<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other"></i>
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="150px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <!-- <el-form-item
            label="单位名称"
            prop="company_num"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-select v-model="form.company_num" filterable="">
              <el-option
                v-for="(item, index) in units"
                :key="index"
                :label="item.c_name"
                :value="item.c_company_num"
              >
                {{ item.c_name }}</el-option
              >
            </el-select>
          </el-form-item> -->
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="维保项目" prop="percentage_name" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.percentage_name" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="发现问题占比（%）" prop="percentage_score" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.percentage_score" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="解决问题占比（%）" prop="percentage_lose" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.percentage_lose" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="维保时间" prop="creation_time" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-date-picker v-model="form.creation_time" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <el-input @change="compute($event, 3)" type="textarea" v-model="form.remark" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="btn-box">
        <div class="l-btn" @click="onSubmit">保存</div>
        <div class="l-btn ml20" @click="$router.back()">返回</div>
      </div>
    </el-form>
  </div>
</template>

<script>
// import getLoation from './getLoation'
import OSS from "ali-oss";

export default {
  components: {},
  data() {
    return {
      form: {
        company_num: "",
        percentage_name: "",
        percentage_score: "", //发现问题占比
        percentage_lose: "", // 解决问题占比
        creation_time: "",
        remark: "", //备注
      },
      units: [],
      // infoOpts:["水位","水压","电气火灾监控设备","用户信息传输装置","无线烟感","RTU","其他"],

      rules: {},
    };
  },
  created() {
    this.$post("/devicemanage/selectconpanybyme").then((res) => {
      this.units = res.data;
    });
    //   this.form.cz_company_num = this.$route.query.c_num

    if (this.$route.query.uuid) {
      this.$post("/score/scoredetails", { uuid: this.$route.query.uuid, uuid_kid: this.$route.query.kid }).then((res) => {
        this.form = res.data;
      });
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    save() {
      let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      let api = this.$route.query.uuid ? "/score/scoreupdate" : "score/scoreinsert";
      this.$post(api, this.form)
        .then((res) => {
          // this.$message.success("保存成功");
          this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
          this.$router.back();
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped></style>
